export const USERS_TRANSLATE = {
    users: {
        breadcrumbName: "Users",
        messages: {
            create: "User added successfully",
            update: "User updated successfully",
            delete: "User deactivated successfully",
            recover: "User restored successfully",
            activeAll: "Permissions activated successfully",
            inactiveAll: "Permissions deactivated successfully"
        },
        listActions: {
            permissions: {
                text: "Permissions"
            }
        },
        list: {
            dialog: {
                delete: {
                    title: "Deactivate User",
                    body: "Are you sure you want to deactivate the account with ID {{id}}",
                    save: {
                        text: "Yes, deactivate"
                    },
                    back: {
                        text: "Back"
                    },
                },
                restore: {
                    title: "Restore Password",
                    body: "A new random password will be generated and sent to the email \"{{user.email}}\"",
                    actions: {
                        primary: "Restore",
                        secondary: "Back"
                    }
                },
                resendEmail: {
                    title: "Resend Confirmation Email",
                    body: "The account verification email will be resent to: \"{{user.email}}\"",
                    actions: {
                        primary: "Resend",
                        secondary: "Back"
                    }
                }
            },
            table: {
                columns: {
                    id: "ID",
                    name: "Name",
                    email: "Email"
                }
            }
        },
        create: {
            title: "Add User"
        },
        update: {
            title: "Edit User"
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Name",
                        placeholder: "Enter the name"
                    },
                    email: {
                        label: "Email",
                        placeholder: "Enter the email"
                    },
                    password: {
                        label: "Password",
                        placeholder: "Enter the password"
                    },
                    passwordConfirmation: {
                        label: "Confirm Password",
                        placeholder: "Enter the password again"
                    }
                }
            }
        },
        permissions: {
            title: "Permissions",
            actions: {
                activateAll: {
                    text: "Activate all"
                },
                inactivateAll: {
                    text: "Deactivate all"
                },
            }
        }
    }
}
